<div class="step-panel">

  <div class="pg-title">
    eMandate setup
    <span class="badge b-b" style="vertical-align:middle;margin-left:8px">Step 11</span>
  </div>
  <div class="pg-sub">
    NACH or UPI Autopay for EMI auto-debit. Mandate status written by NPCI callback
    only — never manually set by admin.
  </div>

  <!-- BANK ACCOUNT CARD -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar"></div>
      Bank account (penny-drop verified)
    </div>
    <div class="fg c2">
      <div class="fl">
        <label>Account <span class="ftag ft-auto">FROM BORROWER</span></label>
        <input class="inp-af inp-ro" type="text"
          value="State Bank of India — XXXX5231 (Savings)" readonly>
      </div>
      <div class="fl">
        <label>Account holder <span class="ftag ft-api">Penny-drop verified</span></label>
        <input class="inp-af inp-ro" type="text"
          value="RAJESH KUMAR SHARMA · ✓ Name match" readonly>
      </div>
    </div>
  </div>

  <!-- MANDATE TYPE CARD -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar"></div>
      Mandate type
    </div>
    <div class="mandate-opts">
      <div class="mo" [class.sel]="mandateType==='enach'" (click)="mandateType='enach'">
        <div class="mo-icon">🏦</div>
        <div class="mo-title">eNACH</div>
        <div class="mo-sub">Debit from bank account on EMI date via NPCI NACH</div>
      </div>
      <div class="mo" [class.sel]="mandateType==='upi'" (click)="mandateType='upi'">
        <div class="mo-icon">📱</div>
        <div class="mo-title">UPI Autopay</div>
        <div class="mo-sub">Auto-debit via UPI mandate (₹1L per transaction limit)</div>
      </div>
    </div>

    <div class="fg c2">
      <div class="fl">
        <label>EMI debit date <span class="req">*</span></label>
        <select [(ngModel)]="emiDate">
          <option>1st of every month</option>
          <option>5th</option>
          <option>10th</option>
          <option>15th</option>
          <option>20th of every month</option>
          <option>25th</option>
        </select>
      </div>
      <div class="fl">
        <label>Mandate status <span class="ftag ft-sys">NPCI CALLBACK ONLY</span></label>
        <input class="inp-ro" type="text" [value]="mandateStatus" readonly>
        <span class="hint warn">This field is written by NPCI callback only. Never manually set.</span>
      </div>
      <div class="fl">
        <label>Mandate start date <span class="ftag ft-auto">AUTO</span></label>
        <input class="inp-af inp-ro" type="text" value="20 May 2024" readonly>
      </div>
      <div class="fl">
        <label>Mandate end date <span class="ftag ft-auto">AUTO</span></label>
        <input class="inp-af inp-ro" type="text" value="20 Apr 2025 (12 EMIs)" readonly>
      </div>
    </div>

    <div style="margin-top:13px;display:flex;gap:8px;flex-wrap:wrap">
      <button class="btn btn-pri" (click)="registerMandate()">Register eNACH mandate</button>
      <button class="btn btn-sec btn-sm" (click)="simulateNpci()">Simulate NPCI callback ↗</button>
    </div>
  </div>

  <!-- MANDATE SUCCESS STATE -->
  <div *ngIf="mandateActive" class="alert ok">
    <span style="flex-shrink:0">✓</span>
    <span>eNACH mandate registered and active. NPCI ref: NPCI-NACH-88421 ·
      SBI XXXX5231 · 20th monthly debit confirmed.</span>
  </div>

  <!-- MANDATE FAIL STATE -->
  <div *ngIf="mandateFailed" class="exc-state err">
    <div class="exc-title">eNACH registration failed — NPCI error EINV-004</div>
    <div class="exc-body">
      Bank account name mismatch. Borrower must re-enter account or switch to UPI Autopay.
    </div>
    <div class="exc-actions">
      <button class="btn btn-err btn-sm">Request new account</button>
      <button class="btn btn-warn btn-sm">Switch to UPI</button>
    </div>
  </div>

  <div class="nav-bar">
    <button class="btn btn-sec" (click)="prev.emit()">← Back</button>
    <button class="btn btn-pri btn-lg" (click)="next.emit()" [disabled]="!mandateActive">Mandate active → Disbursal →</button>
  </div>

</div>
